import * as action_types from "./constants";
import { getChangeOrderDocumentType, getContractDetailType } from "./types";

export type myCompanyState = {
  contractListData: {
    loader: boolean;
    data: [] | null;
    count: number;
  };
  contractDetailData: {
    loader: boolean;
    data: getContractDetailType | null;
  };
  documentData: {
    loader: boolean;
    data: getChangeOrderDocumentType | null;
  };
  contractDetailDataById: {
    loader: boolean;
    data: getContractDetailType | null;
  };
};

const initialState: myCompanyState = {
  contractListData: {
    loader: true,
    data: null,
    count: 0,
  },
  contractDetailData: {
    loader: true,
    data: null,
  },
  documentData: {
    loader: true,
    data: null,
  },
  contractDetailDataById: {
    loader: true,
    data: null,
  },
};

type MyCompanyActionType =
  | {
      type: typeof action_types.GET_CONTRACTS_LISTING;
      data: { payload: []; loading: boolean; count: number };
    }
  | {
      type: typeof action_types.GET_CONTRACTS_DETAIL;
      data: { payload: getContractDetailType | null; loading: boolean };
    }
  | {
      type: typeof action_types.GET_CHANGE_ORDER_DOCUMENT;
      data: { payload: getChangeOrderDocumentType; loading: boolean };
    }
  | {
      type: typeof action_types.GET_CONTRACT_DETAIL_BY_ID;
      data: { payload: getContractDetailType | null; loading: boolean };
    };

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_CONTRACTS_LISTING:
      return {
        ...state,
        contractListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.GET_CONTRACTS_DETAIL:
      return {
        ...state,
        contractDetailData: {
          loader: data?.loading,
          data: data?.payload,
        },
      };

    case action_types.GET_CONTRACT_DETAIL_BY_ID:
      return {
        ...state,
        contractDetailDataById: {
          loader: data?.loading,
          data: data?.payload,
        },
      };

    case action_types.GET_CHANGE_ORDER_DOCUMENT:
      return {
        ...state,
        documentData: {
          loader: data?.loading,
          data: data?.payload,
        },
      };

    default:
      return state;
  }
};

export default myCompanyReducer;
